module.exports = "#bg {\n    position: fixed; \n    top: 0; \n    left: 0; \n      min-width: 100%;\n    min-height: 100%;\n  }\n\n  .input-group{\n    margin-top: 10px;\n  }\n\n  .alert{\n    margin-top:10px;\n  }\n\n  .boton{\n  width:100%;\n  margin-top:10px;\n}\n\n  .boton-twitter{\n  background:#1997F0!important;\n  color: #fff;\n}\n\n  .boton-facebook{\n  background:#395CA9!important;\n  color: #fff;\n}\n\n  .boton-google{\n  background:#D63B30!important;\n  color: #fff;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/autenticacion/inises/inises.component.css
// module id = ./src/app/autenticacion/inises/inises.component.css
// module chunks = main